import { SiteSection } from '../model';
import { LogoComponent } from './LogoComponent';
import { MenuDesktopComponent } from './MenuComponents';
import { ActionsDesktopComponent, ActionsCompactComponent } from './ActionsComponents';
import { useState } from 'react';
import { YandexSearchModalComponent } from './YandexSearchModal';
import { UserComponent } from './UserComponent';

export interface HeaderProps {
	activeSection: SiteSection;
}

const renderYandexSearch = (isSearchOpened: boolean, setIsSearchOpened: (value: boolean) => void) => {
	if (!isSearchOpened)
		return <></>;

	return <YandexSearchModalComponent onHideRequest={() => setIsSearchOpened(false)} />;
}

export const HeaderDesktopComponent = (props: HeaderProps) => {
	const [isSearchOpened, setIsSearchOpened] = useState(false);
	return (
		<>
			<LogoComponent />
			<MenuDesktopComponent activeSection={props.activeSection} />
			<ActionsDesktopComponent requestSearch={() => setIsSearchOpened(true)} />
			<UserComponent />
			{renderYandexSearch(isSearchOpened, setIsSearchOpened)}
		</>
	);
}

export const HeaderCompactComponent = (props: HeaderProps) => {
	const [isMenuExpanded, setIsMenuExpanded] = useState(false);
	const [isSearchOpened, setIsSearchOpened] = useState(false);

	return (
		<div className="wrapper">
			<div className="header-container">
				<LogoComponent />
				<ActionsCompactComponent toggleIsMenuExpanded={() => setIsMenuExpanded(!isMenuExpanded)} requestSearch={() => setIsSearchOpened(true)}/>
				<UserComponent />
				{renderYandexSearch(isSearchOpened, setIsSearchOpened)}
			</div>
			<div className={`menu-container ${isMenuExpanded ? 'expanded' : 'collapsed'}`}>
				<MenuDesktopComponent activeSection={props.activeSection} />
			</div>
		</div>
	);
}